import React from 'react';

import fetch from '../../helper/fetch-helper';
import config from '../../config';
import { getUrlParam, dateUtility, isAlipayMiniProgramBrowser } from '../../helper/common-helper';
import alipayMP from '../../helper/ali-miniprogram-helper';

import './index.scss';

const shopId = getUrlParam('shopId');
const isAlipayMP = isAlipayMiniProgramBrowser();
const ICON_SIZE_HALF = 75 / 2;

export default class HealthIcon extends React.Component {
  el = null;
  boundPreventDefault = false;
  moving = false;

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      callPluginParams: null,
      positions: null,
    };
  }

  componentDidMount() {
    const now = new Date();

    if (!isAlipayMP) {
      return;
    }

    fetch
      .get(config.shopHealthCodeInfoAPI, {
        shopId,
        dateStr: dateUtility.format(now, 'yyyyMMdd'),
      })
      .then(res => {
        const { canShow = false, ...rest } = res || {};

        this.setState({
          visible: canShow,
          callPluginParams: rest,
        });
      });
  }

  setPreventDefault = () => {
    if (!this.el || this.boundPreventDefault) {
      return;
    }

    this.el.addEventListener(
      'touchmove',
      e => {
        if (e.cancelable) {
          e.preventDefault();
        }
      },
      { passive: false },
    );
    this.boundPreventDefault = true;
  };

  handleIconClick = () => {
    // 跳转到插件页
    alipayMP.navigateTo('/pages/merchant-card/merchant-card', this.state.callPluginParams);
  };

  handleTouchStart = () => {
    this.moving = true;
  };

  handleTouchEnd = () => {
    this.moving = false;
  };

  handleTouchMove = e => {
    const point = e.changedTouches[0];

    if (point && this.moving) {
      const { clientX, clientY } = point;
      this.setState({
        positions: {
          top: clientY - ICON_SIZE_HALF,
          left: clientX - ICON_SIZE_HALF,
        },
      });
    }
  };

  render() {
    const { visible, positions } = this.state;

    return isAlipayMP && visible ? (
      <div
        className="health-icon"
        ref={el => {
          this.el = el;
          this.setPreventDefault();
        }}
        style={positions}
        onClick={this.handleIconClick}
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}
      />
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/component/health-icon/index.jsx